var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatTeardropDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 28.2336H5.96246C5.8356 28.2354 5.70968 28.2106 5.59215 28.1606C5.47461 28.1107 5.36784 28.0366 5.27813 27.9428C5.18841 27.849 5.11758 27.7373 5.0698 27.6144C5.02203 27.4915 4.99828 27.3598 4.99996 27.2272V16.2082C4.99996 13.0189 6.21156 9.96015 8.36823 7.70494C10.5249 5.44973 13.45 4.18277 16.5 4.18277V4.18277C18.0102 4.18277 19.5056 4.49382 20.9008 5.09815C22.2961 5.70249 23.5638 6.58827 24.6317 7.70494C25.6996 8.8216 26.5466 10.1473 27.1246 11.6063C27.7025 13.0653 28 14.629 28 16.2082V16.2082C28 17.7874 27.7025 19.3512 27.1246 20.8101C26.5466 22.2691 25.6996 23.5948 24.6317 24.7115C23.5638 25.8281 22.2961 26.7139 20.9008 27.3183C19.5056 27.9226 18.0102 28.2336 16.5 28.2336V28.2336Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17.7767C17.0523 17.7767 17.5 17.3086 17.5 16.7311C17.5 16.1535 17.0523 15.6854 16.5 15.6854C15.9477 15.6854 15.5 16.1535 15.5 16.7311C15.5 17.3086 15.9477 17.7767 16.5 17.7767Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 17.7767C11.0523 17.7767 11.5 17.3086 11.5 16.7311C11.5 16.1535 11.0523 15.6854 10.5 15.6854C9.94772 15.6854 9.5 16.1535 9.5 16.7311C9.5 17.3086 9.94772 17.7767 10.5 17.7767Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 17.7767C23.0523 17.7767 23.5 17.3086 23.5 16.7311C23.5 16.1535 23.0523 15.6854 22.5 15.6854C21.9477 15.6854 21.5 16.1535 21.5 16.7311C21.5 17.3086 21.9477 17.7767 22.5 17.7767Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatTeardropDots);
export default __webpack_public_path__ + "static/media/ChatTeardropDots.83951fef39f625c365f0bae34474adc2.svg";
export { ForwardRef as ReactComponent };